import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function PriceLow(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.priceLow()) {
    return currentValue;
  }

  // Determine if the listing matches the filter.
  const _value = parseInt(this.filteringService.priceLow(), 10);
  if (_value > (listing.price || 0)) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
